import React, {Component, PropTypes} from 'react';
import {formatTime} from 'utils';

export default class Timestamp extends Component {
    static propTypes = {
        time: PropTypes.number.isRequired,
    };

    shouldComponentUpdate() {
        return false;
    }

    render() {
        return (
            <span className='cielo24-vwrap-timestamp' aria-hidden={true}>
                <i className='cielo24-vwrap-icon cielo24-vwrap-icon-clock' />
                <span>{formatTime(this.props.time)}<br /></span>
            </span>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/transcript/timestamp.js